import React, { FC, useState } from 'react';
import { ListingEntry } from 'graphql/listings/queries';
import { ChargeFormEntry } from 'views/orders/charges/components/GeneralChargesTable/types';
import { useChargeFieldSync } from 'views/orders/charges/components/GeneralChargesTable/components/ChargesTableRow/useChargeFieldSync';
import { ChargeCard } from './ChargeCard';
import { ChargeDocumentCard } from './ChargeDocumentCard';

interface Props {
  charge: ChargeFormEntry;
  index: number;
  currentLetter?: string;
  lettersPerMonth: string[];
  textPredectiveCharges: ListingEntry[];
  formatedAccountingData: ChargeFormEntry[];
  hideTax: boolean;
  isOrderTypeNotHUD1: boolean;
  onDeleteCharge: (rowIndex: number) => void;
  onEditCharge: (charge: ChargeFormEntry, rowIndex: number) => void;
  onEditSplitAmount: (charge: ChargeFormEntry, kind: 'Payee' | 'Payer' | 'Tax') => void;
}

export const ChargeCardRow: FC<Props> = (props) => {
  const {
    charge,
    onDeleteCharge,
    onEditCharge,
    index,
    isOrderTypeNotHUD1,
    currentLetter,
  } = props;
  const [open, setOpen] = useState(false);

  const {
    handleAmountFieldChange,
    handlePaidByAmountChange,
    handleNumberOfMontsFieldChange,
    handlePerMonthAmountFieldChange,
  } = useChargeFieldSync({ index, currentLetter, isOrderTypeNotHUD1 });

  const handleToggleRowOpen = () => {
    setOpen((prevValue) => !prevValue);
  };

  const chargeIsDocument = charge.code === 'document';

  return chargeIsDocument ? (
    <ChargeDocumentCard
      {...props}
      onDelete={onDeleteCharge}
      onEdit={onEditCharge}
      isPartiesInvolvedRowOpen={open}
      togglePartiesinvolvedRowOpen={handleToggleRowOpen}
      onChargeAmountChange={handleAmountFieldChange}
      onChargePaidByAmountChange={handlePaidByAmountChange}
    />
  ) : (
    <ChargeCard
      {...props}
      isPartiesInvolvedRowOpen={open}
      togglePartiesinvolvedRowOpen={handleToggleRowOpen}
      onChargeAmountChange={handleAmountFieldChange}
      onChargePaidByAmountChange={handlePaidByAmountChange}
      onChargeNumberOfMonthsChange={handleNumberOfMontsFieldChange}
      onPerMonthChange={handlePerMonthAmountFieldChange}
    />
  );
};
